export const COMPOSE_ONLY_ATTACHMENT_CONTENT_START = 'owa-attachment-remove-on-send-start';
export const COMPOSE_ONLY_ATTACHMENT_CONTENT_END = 'owa-attachment-remove-on-send-end';
